import script from "./AttachmentFile.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentFile.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentFile.vue?vue&type=style&index=0&id=1fa71d74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa71d74"]])

export default __exports__